import { render, staticRenderFns } from "./Maximize.vue?vue&type=template&id=fc87df86&scoped=true&"
import script from "./Maximize.vue?vue&type=script&lang=js&"
export * from "./Maximize.vue?vue&type=script&lang=js&"
import style0 from "./Maximize.vue?vue&type=style&index=0&id=fc87df86&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc87df86",
  null
  
)

export default component.exports